/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import vueXlsxTable from 'vue-xlsx-table'
Vue.use(vueXlsxTable, {rABS: false}) //Browser FileReader API have two methods to read local file readAsBinaryString and readAsArrayBuffer, default rABS false
import Datepicker from 'vuejs-datepicker';
import {sk} from 'vuejs-datepicker/dist/locale'

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

let localePrefix = document.documentElement.lang;

Vue.mixin({
	methods: {
		text_translation: function (slovakString = '', germanString = '', enString = '') {
			if(localePrefix === 'sk') {
				return slovakString;
			}

			if(localePrefix === 'en') {
				return enString;
			}

			if(localePrefix === 'de') {
				return germanString;
			}
		}
	}
})

Vue.component('faq', require('./components/FaqComponent.vue').default);
Vue.component('newsletter', require('./components/NewsletterComponent.vue').default);
Vue.component('footer-newsletter', require('./components/FooterNewsletter.vue').default);
Vue.component('contact-form', require('./components/ContactFormComponent.vue').default);
Vue.component('documents', require('./components/DocumentsComponent.vue').default);
Vue.component('cart-menu', require('./components/CartMenuComponent.vue').default);
Vue.component('article-gallery', require('./components/ArticleGalleryComponent.vue').default);
Vue.component('family-registration', require('./components/FamilyRegistrationComponent.vue').default);
Vue.component('school-registration', require('./components/SchoolRegistrationComponent.vue').default);
Vue.component('school-club-registration', require('./components/SchoolClubRegistrationComponent.vue').default);
Vue.component('contact', require('./components/AboutContactForm.vue').default);
Vue.component('text-with-dictionary', require('./components/TextWithDictionary.vue').default);
Vue.component('dropzone', require('./components/DropZoneUploader.vue').default);
Vue.component('cart-menu', require('./components/CartMenuComponent.vue').default);
Vue.component('products-filter', require('./components/ProductsFilterComponent.vue').default);
Vue.component('products-sort', require('./components/ProductsSortComponent.vue').default);
Vue.component('cart', require('./components/CartComponent.vue').default);
Vue.component('cart-product-button', require('./components/CartProductButton.vue').default);
Vue.component('add-to-cart', require('./components/AddToCart.vue').default);
Vue.component('product-gallery', require('./components/ProductGalleryComponent.vue').default);
Vue.component('similar-products', require('./components/SimilarProducts.vue').default);
Vue.component('checkout-button', require('./components/CheckoutButton.vue').default);
Vue.component('registration-pricing', require('./components/RegistrationPricing.vue').default);
Vue.component('academy-task', require('./components/AcademyTaskComponent.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
	el: '#app',
	components: {
		Datepicker
	},
	data: function() {
		return {
			sk: sk
		}
	}
});
